import { render } from "./form_renderer.vue?vue&type=template&id=6248488c"
import script from "./form_renderer.vue?vue&type=script&lang=js"
export * from "./form_renderer.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/inspection_reports/forms/form_renderer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6248488c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6248488c', __exports__)) {
    console.log('reload')
    api.reload('6248488c', __exports__)
  }
  
  module.hot.accept("./form_renderer.vue?vue&type=template&id=6248488c", () => {
    console.log('re-render')
    api.rerender('6248488c', render)
  })

}


export default __exports__